const titleSx = {
  fontWeight: 600,
  fontSize: 16,
  fontFamily: 'Plus Jakarta Sans',
  color: '#000000',
  textTransform: 'capitalize'
}
const titleSxDisabled = {
  fontWeight: 600,
  fontSize: 16,
  fontFamily: 'Plus Jakarta Sans',
  color: '#76767D',
  textTransform: 'capitalize'
}
const descriptionSx = {
  fontSize: '16px',
  fontWeight: 400,
  fontFamily: 'Plus Jakarta Sans',
  color: '#76767D',
  mb: 2,
  whiteSpace: 'normal',
  wordBreak: 'break-word'
}
const descriptionDisabledSx = {
  fontSize: '16px',
  fontWeight: 400,
  fontFamily: 'Plus Jakarta Sans',
  color: '#76767D',
  mb: 2,
  opacity: 0.5,
  whiteSpace: 'normal',
  wordBreak: 'break-word'
}

const buttonSx = {
  borderRadius: '16px',
  fontFamily: 'Plus Jakarta Sans',
  fontWeight: 400,
  fontSize: '16px',
  padding: '8px 8px',
  backgroundColor: '#0246F8',
  boxShadow: 'none',
  color: '#fff',
  textTransform: 'none',
  flexGrow: 1,
  minWidth: '180px',
  '&:hover': { backgroundColor: '#1d4ed8' },
  '&.Mui-disabled': {
    backgroundColor: '#e0e0e0',
    color: '#757575'
  }
}
const alertSx = severity => ({
  mt: 2,
  alignItems: 'center',
  fontWeight: 400,
  fontSize: 16,
  fontFamily: 'Plus Jakarta Sans',
  borderRadius: '16px',
  backgroundColor: severity === 'success' ? '#00BC6226' : '#FFF4F4',
  color: '#1B1B26',
  border: `1px solid ${severity === 'success' ? '#00BC624D' : '#D32F2F'}`
})

export { titleSx, titleSxDisabled, descriptionSx, buttonSx, descriptionDisabledSx, alertSx }
